import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { AUTH_ROUTES } from '@app/shared/utilities/auth-routes';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isLoggedIn = !!localStorage.getItem('bearerToken');
    if (!isLoggedIn) {
      this.router.navigate([AUTH_ROUTES.signUp]);
      return false;
    }

    const claimType: string = next.data['claimType'];
    if (claimType && !this.authService.hasClaim(claimType)) {
      this.router.navigate(['/404']);
      return false;
    }

    return true;
  }
}
